import dayjs from 'dayjs';

import { useMemo } from 'react';

import ReportCard from 'components/charts/ReportCard';

import useAccessControl from 'hooks/useAccessControl';

import PATHS from 'utils/paths';

const OtoPackReports = () => {
	const isAuthorized = useAccessControl();
	const otopackReports = useMemo(
		() => [
			{
				title: 'binTransactions',
				subTitle: 'binTransactionsSubtitle',
				actionLabel: 'generate',
				actionPath: PATHS.BIN_TRANSACTIONS
			},
			{
				title: 'inventoryTransactions',
				subTitle: 'inventoryTransactionsSubtitle',
				actionLabel: 'generate',
				actionPath: PATHS.INVENTORY_TRANSACTIONS
			},
			{
				title: 'replenishmentReport',
				subTitle: 'replenishmentReportSubtitle',
				actionLabel: 'generate',
				actionPath: PATHS.REPLENISHMENT_REPORT
			},
			{
				title: 'wmsExceptionsLogsListing',
				subTitle: 'pickingNASubtitle',
				actionLabel: 'generate',
				actionPath: PATHS.PICKING_EXCEPTION_LOGS
			},
			{
				title: 'dailyStaff',
				subTitle: 'dailyStaffSubtitle',
				actionLabel: 'generate',
				actionPath: PATHS.DAILY_STAFF,
				filterArray: [
					{
						label: 'dateInterval',
						component: 'dateInput',
						name: 'date',
						required: true,
						minDate: dayjs().subtract(30, 'day').startOf('day').toISOString(),
						maxDate: dayjs().endOf('day').toISOString()
					}
				]
			},
			{
				title: 'stockUpdateReports',
				subTitle: 'stockUpdateReportsSubtitle',
				actionLabel: 'generate',
				actionPath: PATHS.STOCK_UPDATE_REPORTS
			},

			{
				title: 'orderBasedTransactionReports',
				subTitle: 'orderBasedTransactionReportsSubtitle',
				actionLabel: 'generate',
				actionPath: PATHS.ORDER_BASED_TRANSACTION
			},
			{
				title: 'waveBasedTransactionReports',
				subTitle: 'waveBasedTransactionReportsSubtitle',
				actionLabel: 'generate',
				actionPath: PATHS.WAVE_BASED_TRANSACTION
			},
			{
				title: 'packingStatusReports',
				subTitle: 'packingStatusReportsSubtitle',
				actionLabel: 'generate',
				actionPath: PATHS.PACKING_STATUS_REPORTS
			}
		],
		[]
	);

	return (
		<div className="row row-cols-1 row-cols-lg-2">
			{otopackReports
				.filter((item) => isAuthorized(item.actionPath))
				.map((item, index) => (
					<ReportCard
						key={index}
						title={item.title}
						subTitle={item.subTitle}
						actionPath={item.actionPath}
						actionLabel={item.actionLabel}
						filterArray={item.filterArray}
					/>
				))}
		</div>
	);
};

export default OtoPackReports;
